import { trackEvent } from './javascripts/util/analytics'

up.network.config.progressBar = false

// Clicking up-modal-dismiss should be tracked, but we need to bind explicitly for every modal that open,
// because Unpoly would consume the event before we could handle it on document.
up.on('up:layer:opened', () => {
  $('up-modal-dismiss').on('click', () => {
    trackEvent('modal.closeButton.click')
  })
})
